/* global scacBusinesses, scacEvents, L */

// ── Business listing ──────────────────────────────────────────────────────────

(function () {
  if (!document.getElementById('scac-biz-grid')) return;

  var cfg      = window.scacBusinesses;
  var map      = null;
  var markers  = [];
  var debounce = null;

  function getFilters() {
    var chamber  = [];
    var industry = [];
    document.querySelectorAll('.scac-filter-input[data-taxonomy="chamber"]:checked').forEach(function (el) {
      chamber.push(el.value);
    });
    document.querySelectorAll('.scac-filter-input[data-taxonomy="industry"]:checked').forEach(function (el) {
      industry.push(el.value);
    });
    return {
      chamber:  chamber,
      industry: industry,
      search:   document.getElementById('scac-search').value.trim(),
    };
  }

  function fetchBusinesses() {
    var f = getFilters();
    document.getElementById('scac-spinner').style.display = 'flex';

    var data = new FormData();
    data.append('action', 'scac_filter_businesses');
    data.append('nonce', cfg.nonce);
    f.chamber.forEach(function (v)  { data.append('chamber[]', v); });
    f.industry.forEach(function (v) { data.append('industry[]', v); });
    data.append('search', f.search);

    fetch(cfg.ajaxUrl, { method: 'POST', body: data })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        document.getElementById('scac-spinner').style.display = 'none';
        if (!res.success) return;

        document.getElementById('scac-grid-results').innerHTML = res.data.html;
        document.getElementById('scac-result-count').textContent = res.data.total;

        // Reset filter button visibility
        var hasFilters = f.chamber.length || f.industry.length || f.search;
        document.getElementById('scac-reset-filters').style.display = hasFilters ? '' : 'none';

        // Rebuild map markers
        if (map) {
          markers.forEach(function (m) { map.removeLayer(m); });
          markers = [];
          buildMapMarkers(res.data.markers);
        }
      });
  }

  // Filter inputs
  document.querySelectorAll('.scac-filter-input').forEach(function (el) {
    el.addEventListener('change', fetchBusinesses);
  });

  // Live search
  document.getElementById('scac-search').addEventListener('input', function () {
    clearTimeout(debounce);
    debounce = setTimeout(fetchBusinesses, 300);
  });

  // Reset
  document.getElementById('scac-reset-filters').addEventListener('click', function () {
    document.querySelectorAll('.scac-filter-input').forEach(function (el) { el.checked = false; });
    document.getElementById('scac-search').value = '';
    fetchBusinesses();
  });

  // View toggle
  document.querySelectorAll('.scac-view-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.scac-view-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      var view = btn.dataset.view;
      document.getElementById('scac-biz-grid').style.display = view === 'grid' ? '' : 'none';
      document.getElementById('scac-biz-map').style.display  = view === 'map'  ? '' : 'none';

      if (view === 'map' && !map) initMap();
    });
  });

  function initMap() {
    // Start with a neutral view — fitBounds() will correct it once markers load
    map = L.map('scac-leaflet-map').setView([40.9265, -72.6374], 11);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19,
    }).addTo(map);

    var icon = L.icon({ iconUrl: cfg.poiUrl, iconSize: [32, 40], iconAnchor: [16, 40], popupAnchor: [0, -40] });
    map._scacIcon = icon;
    fetchBusinesses(); // populates markers via buildMapMarkers + fits bounds
  }

  function buildMapMarkers(data) {
    if (!map) return;
    var icon = map._scacIcon;
    var bounds = L.latLngBounds();

    data.forEach(function (b) {
      var latlng = L.latLng(b.lat, b.lng);
      var m = L.marker(latlng, { icon: icon }).addTo(map);
      m.bindPopup(
        '<strong>' + escHtml(b.title) + '</strong>' +
        (b.address ? '<br>' + escHtml(b.address) : '') +
        (b.phone   ? '<br>' + escHtml(b.phone)   : '') +
        '<br><a href="' + b.link + '">View Profile →</a>'
      );
      markers.push(m);
      bounds.extend(latlng);
    });

    if (bounds.isValid()) {
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 15 });
    } else {
      // No geocoded markers — fall back to Suffolk County overview
      map.setView([40.9265, -72.6374], 10);
    }
  }

  function escHtml(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  // Initial load
  fetchBusinesses();
})();


// ── Events listing ────────────────────────────────────────────────────────────

(function () {
  if (!document.getElementById('scac-event-grid')) return;

  var cfg      = window.scacEvents;
  var debounce = null;

  function getFilters() {
    var active = document.querySelector('.scac-type-btn.active');
    var termId = active ? active.dataset.term : '0';
    return {
      event_type: termId !== '0' ? [termId] : [],
      date_from:  document.getElementById('scac-date-from').value,
      date_to:    document.getElementById('scac-date-to').value,
    };
  }

  function fetchEvents() {
    var f = getFilters();
    document.getElementById('scac-event-spinner').style.display = 'flex';

    var data = new FormData();
    data.append('action', 'scac_filter_events');
    data.append('nonce', cfg.nonce);
    f.event_type.forEach(function (v) { data.append('event_type[]', v); });
    data.append('date_from', f.date_from);
    data.append('date_to',   f.date_to);

    fetch(cfg.ajaxUrl, { method: 'POST', body: data })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        document.getElementById('scac-event-spinner').style.display = 'none';
        if (!res.success) return;
        document.getElementById('scac-event-results').innerHTML   = res.data.html;
        document.getElementById('scac-event-count').textContent   = res.data.total;
      });
  }

  // Type filter buttons
  document.querySelectorAll('.scac-type-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.scac-type-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      fetchEvents();
    });
  });

  // Date pickers
  var resetBtn = document.getElementById('scac-date-reset');
  function updateResetVisibility() {
    var from = document.getElementById('scac-date-from').value;
    var to   = document.getElementById('scac-date-to').value;
    if (resetBtn) resetBtn.classList.toggle('visible', !!(from || to));
  }

  ['scac-date-from', 'scac-date-to'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('change', function () {
      updateResetVisibility();
      clearTimeout(debounce);
      debounce = setTimeout(fetchEvents, 200);
    });
  });

  // Reset filter
  if (resetBtn) resetBtn.addEventListener('click', function () {
    document.getElementById('scac-date-from').value = '';
    document.getElementById('scac-date-to').value   = '';
    // reset type buttons too
    document.querySelectorAll('.scac-type-btn').forEach(function(b) { b.classList.remove('active'); });
    var allBtn = document.querySelector('.scac-type-btn[data-term="0"]');
    if (allBtn) allBtn.classList.add('active');
    updateResetVisibility();
    fetchEvents();
  });

  // Initial load
  fetchEvents();
})();
